import { render, staticRenderFns } from "./wtAspectRatioSelector.component.vue?vue&type=template&id=0f4cdac8&scoped=true&"
import script from "./wtAspectRatioSelector.component.vue?vue&type=script&lang=js&"
export * from "./wtAspectRatioSelector.component.vue?vue&type=script&lang=js&"
import style0 from "./wtAspectRatioSelector.component.vue?vue&type=style&index=0&id=0f4cdac8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4cdac8",
  null
  
)

export default component.exports